import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import { Button, TableOperationHeader } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import {
  updateMyScheduleSearchTerm,
  selectMyScheduleSearchTerm,
} from 'state/Schedule/ScheduleSlice';
import SettingsModal from 'Pages/LearningSchedule/components/SettingsModal/SettingsModal';
import {
  getUserSettingValues,
  getViewSettingValues,
} from 'state/ViewSettings/viewSettingsSlice';
import SettingsIcon from 'assets/icons/configure.svg';
import { useFlags } from 'launchdarkly-react-client-sdk';
const MyScheduleHeader = () => {
  const dispatch = useDispatch();
  const search = useSelector(selectMyScheduleSearchTerm);
  const [searchTerm, setSearchTerm] = useState(search);
  const { fmPublicHolidays = false } = useFlags<{
    fmPublicHolidays: boolean;
  }>();

  const [showSettingsModal, setShowSettingsModal] = useState(false);

  useEffect(() => {
    if (fmPublicHolidays) {
      dispatch(getUserSettingValues());
      dispatch(getViewSettingValues(['FM_CONFIGURATION_OPTIONS']));
    }
  }, [dispatch, fmPublicHolidays]);
  const handleShowSettingsModal = () => {
    setShowSettingsModal(true);
  };
  const debouncedHandleSearch = useMemo(() => {
    return debounce((value: string) => {
      dispatch(updateMyScheduleSearchTerm({ search: value }));
    }, 500);
  }, [dispatch]);

  return (
    <>
      {fmPublicHolidays ? (
        <SettingsModal
          showModal={showSettingsModal}
          onClose={() => setShowSettingsModal(false)}
        />
      ) : null}
      <TableOperationHeader
        className='border-b-0'
        inputValue={searchTerm}
        actionButtons={
          fmPublicHolidays ? (
            <Button
              data-testid='my-schedule-settings_button'
              onClick={handleShowSettingsModal}
              variant='tertiary'
              size='small'
              iconPosition='left'
              iconSrc={SettingsIcon}
            >
              {intl.get('SCHEDULE.SETTINGS_BUTTON')}
            </Button>
          ) : null
        }
        setInputValue={(value: string) => {
          setSearchTerm(value);
          debouncedHandleSearch(value);
        }}
        searchProps={{
          'data-testid': 'my-schedule-search_input',
          placeholder: intl.get('SCHEDULE.SEARCH_BY_EVENT'),
        }}
      />
    </>
  );
};

export default MyScheduleHeader;
